<template>
  <div>
    <el-dialog v-dialogDrag :title="title" :visible.sync="isDialog" width="700px" @opened="initData" @close="clearFun('user')" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="small" :model="user" ref="user" :rules="rules" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号：" prop="username">
              <el-input v-model="user.username" placeholder="账号" maxlength="20"/>
            </el-form-item>
            <el-form-item label="密码：" prop="password">
              <el-input type="password" v-model="user.password" placeholder="密码" maxlength="50"/>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="user.name" placeholder="姓名" maxlength="50"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像：" prop="avatar">
              <image-upload ref="avatar" :url="user.avatar" :on-change="changeAvatar" width="115px" height="115px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="性别：" prop="gender">
              <el-select v-model="user.gender" clearable placeholder="请选择性别" class="width-full">
                <el-option v-for="item in dicts['GENDER']" :key="item.value" :value="parseInt(item.value)" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话：" prop="phone">
              <el-input v-model="user.phone" placeholder="电话" maxlength="20"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="user.email" placeholder="电子邮箱" maxlength="50"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态：" prop="enable">
              <el-select placeholder="请选择状态" v-model="user.enable" class="width-full">
                <el-option v-for="item in dicts['DATA_STATE']" :key="item.id" :value="parseInt(item.value)" :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生日：" prop="birthday">
              <el-date-picker v-model="user.birthday" placeholder="生日" value-format="yyyy-MM-dd" format="yyyy-MM-dd" class="width-full"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="住址：" prop="address">
              <el-input v-model="user.address" placeholder="住址" maxlength="300"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="描述信息：" prop="description">
              <el-input type="textarea" v-model="user.description" maxlength="500" placeholder="描述信息" rows="4" show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="isDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="submitFun('user')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageUpload from '@/views/models/ImageUpload'

export default {
  name: 'AddOrUpdate',
  components: {ImageUpload},
  props: {
    //列表刷新
    refresh: {
      type: Function
    }
  },
  data() {
    return {
      //标题
      title: '新增',
      //是否打开弹窗
      isDialog: false,
      //数据
      user: {
        enable: 1,
        type: 1
      },
      //验证规则
      rules: {
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }, {
          validator: this.checkUsername,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }]
      },
      //数据字典
      dicts: {},
      //头像
      avatar: null,
      //类型（管理员）
      type: 1
    }
  },
  methods: {
    //用户名重复校验
    checkUsername: function(rule, value, callback) {
      this.$axios.get('/sysUser/checkUsername', {
        params: {
          username: value,
          id: this.user.id,
          type: this.type
        }
      }).then(response => {
        if(response){
          callback(new Error('账号已经存在'))
        }
        else {
          callback()
        }
      })
    },
    //提交
    submitFun: function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //管理员类型固定
          this.user.type = this.type
          //头像图片上传
          if(this.avatar) {
            //上传头像
            this.upload()
          } else {
            //数据提交保存
            this.saveData()
          }
        } else {
          return false
        }
      })
    },
    //头像上传
    upload: function(){
      let form = new FormData()
      form.append('path', 'user')
      form.append('file', this.avatar.raw)
      //上传文件
      this.$axios({
        method: 'post',
        url: '/fileUpload/upload',
        data: form,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        //头像地址
        this.user.avatar = res ? res.path : null
        //数据提交保存
        this.saveData()
      })
    },
    //数据提交
    saveData: function(){
      this.$axios({
        method: 'post',
        url: '/sysUser/saveOrUpdate',
        data: this.user
      }).then(() => {
        this.refresh()
        this.isDialog = false
        this.$message.success('保存成功~')
      })
    },
    //清除表单数据
    clearFun: function(formName){
      this.$refs[formName].resetFields()
      //默认值回复
      this.user = {
        enable: 1,
        type: 1
      }
      this.avatar = null
      this.$refs.avatar.fileList = []
    },
    //打开窗口时初始化操作
    initData: function(){
      //数据字典
      this.$axios.get('/sysConfig/selectByPcodeList', { params: { pcodeList: 'GENDER, DATA_STATE' } }).then(response => this.dicts = response)
      //清除验证结果
      this.$refs.user.clearValidate()
    },
    //头像改变
    changeAvatar: function(file){
      this.avatar = file
      if(!file){
        //当头像改变后，清空头像属性
        this.user.avatar = ''
      }
    }
  }
}
</script>

<style scoped>
  .width-full {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/user/AddOrUpdate.vue